import * as React from 'react';
import Image from 'next/image';

type IAboutTwoProps = object;

const AboutTwo: React.FunctionComponent<IAboutTwoProps> = () => {
  return (
    <section id='about' className='pb-20 lg:pb-25 xl:pb-30 overflow-hidden pt-30'>
      {/* Header added here */}
      <h1 className='text-black text-4xl xl:text-hero font-bold mb-10 pl-45'>SEO Content </h1>
      <h4 className='text-black text-lg font-medium mb-10 pl-45'>
        Create revenue-generating content
      </h4>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 xl:px-0'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left hidden md:block md:w-1/2'>
            <Image src='/images/products/content/contents.png' alt='About' width={600} height={400} />
          </div>
          <div className='animate_right md:w-1/2'>
            <h4 className='text-black  font-medium uppercase'>
              Focus on content that buyers care about
            </h4>
            <h2 className='relative font-bold text-black  text-3xl xl:text-hero mb-6'>
              Auto generate content with{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg before:-z-1'>
                AI assistance
              </span>
            </h2>
            <p>Content based on what buyers are looking for:</p>
            <ul className='list-disc list-inside'>
              <li>AI agent analyzes conversations</li>
              <li>Leverage SEO best practices</li>
              <li>Content styling based on existing pages</li>
              <li>Create organic growth without spending hours</li>
            </ul>
          </div>
        </div>
      </div>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 2xl:px-0 pt-30'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Pre made templates</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Automate your manual work{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg2 before:-z-1'>
                in seconds
              </span>
            </h2>
            <p>Your competition wont stand a chance:</p>
            <ul className='list-disc list-inside'>
              <li>Templates based on SEO analysis</li>
              <li>Repurpose your existing content</li>
              <li>Create your own templates</li>
            </ul>
          </div>
          <div className='animate_right hidden md:block md:w-1/2'>
            <Image src='/images/products/content/articles.png' alt='About' width={600} height={400} />
            <Image src='/images/about/about-dark-02.svg' alt='About' width={600} height={400} className='hidden' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
